{
  "version": 1,
  "asset_id": "22f7e966-7c7e-4b34-a074-b463d30aef22",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/22f7e966-7c7e-4b34-a074-b463d30aef22/appliances-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/22f7e966-7c7e-4b34-a074-b463d30aef22/appliances-card.webp",
  "original_filename": "appliances-card.webp",
  "size": 24024,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:29:58Z"
}
